import { defineStyle, defineStyleConfig } from "@chakra-ui/styled-system";



const baseStyle = defineStyle({
  borderRadius: "var(--button-radius, 0)",
  bg: "var(--button-bg)",
  transition: "background-color border-color 200ms",
  _active: {
    transform: "scale(99%)",
  },
  _focus: {
    outline: "var(--button-outline-width, var(--button-border-width))",
    outlineOffset: "var(--button-outline-offset,calc(var(--button-border-width) * 2))",
    outlineColor: "var(--button-outline-color, var(--button-border-color))",
    outlineStyle: "var(--button-outline-style, var(--button-border-style))",
  },
  _hover: {
    bg:"var(--button-hover-bg)"
  },
  _disabled: {
    bg: "var(--button-disabled-bg)",
    boxShadow: "none",
    color: "var(--button-disabled-color)"
  }
})

const variants = defineStyle({
   base : {
    // paddingX:"var(--button-inline-padding)",
    padding:"var(--button-padding, 0.7em 0.7em)",
    color: "var(--button-color)",
      /* Stroke and radius */
    borderWidth: "var(--button-border-width)",
    borderStyle: "var(--button-border-style)",
    borderColor:"var(--button-border-color)",
    fontSize: "var(--button-font-size, 1rem)",
    height: "var(--button-height)",
    fontWeight: 500,
    fontFamily: "font4",
   }
})


export const buttonTheme = defineStyleConfig({
  baseStyle,
 variants,
 defaultProps: {
  variant: 'base'
 }
});

